define.alias("shared/components/shared/wistia-video", "settings/components/shared/wistia-video");